export enum RedirectErrors
{
    NoOrgAssigned = 1,
    NotFound = 2,
    NoAccess = 3,
}
